import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { YearColumns } from "../../../tableColumns/table-columns";
import { leaveYearJson } from "../../../DynamicFormsJson/MastersJSON/leaveYear";
import { getLeaveYear } from "../../../Slice/year.slice";

class LeaveYearTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { yearList, getLeaveYear } = this.props;
        return (
            <>
                <DynamicMainScreen
                    formPath={leaveYearJson.formPath}
                    screenTitle={leaveYearJson.screenTitle}
                    fieldMeta={leaveYearJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={leaveYearJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={leaveYearJson.pdfFileName}
                    excelFileName={leaveYearJson.excelFileName}
                    showAddButton={leaveYearJson.showAddButton}
                    tableColumnsToFilter={leaveYearJson.tableColumnsToFilter}
                    tableColumns={YearColumns}
                    tableData={yearList?.leaveYear}
                    getTableData={getLeaveYear}
                    apiBaseURL={leaveYearJson.apiBaseURL}
                    baseIdColumn={leaveYearJson.baseIdColumn}
                    isNote={true}
                    isNoteValue={"Add Leave Year"}
                    showDeleteIcon={true}
                    showViewButtonInTable={true}
                    formPathView={leaveYearJson.formPathView}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    yearList: state.year,
});
const mapDispatchToProps = {
    getLeaveYear,
};
export default connect(mapStateToProps, mapDispatchToProps)(LeaveYearTable);
